import React from 'react';
import T from 'prop-types';

import AppInfo from './AppInfo';
import Button from '../../../../components/Buttons/Button';

const FavoriteComparisons = ({ comparisons, isMobileView }) => {
  const iconSize = isMobileView ? 40 : 48;

  return (
    <div className="favorite-comparisons shared-competitors-comparisons">
      <h2 className="h2">{comparisons.header_text}</h2>
      <div
        className="paragraph"
        dangerouslySetInnerHTML={{
          __html: comparisons.sub_header_text,
        }}
      />
      <div className="apps-list">
        {comparisons.apps.map((app, index) => (
          <a key={index} className="app-item" href={app.apps_comparison_link_url}>
            <div className="compared-apps">
              <AppInfo
                app={app.first_app}
                size={iconSize}
                direction={isMobileView ? 'vertical' : 'horizontal'}
                enableTooltip={!isMobileView}
              />
              <p className="divider">vs</p>
              <AppInfo
                app={app.second_app}
                size={iconSize}
                direction={isMobileView ? 'vertical' : 'horizontal'}
                enableTooltip={!isMobileView}
              />
            </div>
            {!isMobileView && (
              <Button className="app-link" variant="light" shape="square">
                <i className="hicon-angle-up-new" />
              </Button>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

FavoriteComparisons.propTypes = {
  comparisons: T.shape({
    header_text: T.string,
    sub_header_text: T.string,
    apps: T.array,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default FavoriteComparisons;
